import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../components/Loader';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class VehiclePropertyLoadableComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    if (this.props.loading)
      return (
        <div className={`loading vehicle-property-loadable ${this.props.className || ''}`}>
          {this.props.hideChildrenOnLoad === false ? this.props.children : <Loader small />}
        </div>
      );
    return <div className={`vehicle-property-loadable ${this.props.className || ''}`}>{this.props.children}</div>;
  }
}

VehiclePropertyLoadableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWorks([`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${ownProps.name}`, ownProps.name]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehiclePropertyLoadable = compose(withConnect, withRouter)(VehiclePropertyLoadableComp);
